export const API_KEY = '3646fbc35338ebf7e2d0e8de6aa1d20c';
export const BASE_URL = 'https://api.openweathermap.org/';